import { apiEquipments } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'equipments';

const config = [
  { actionType: 'getAll', apiPath: apiEquipments, method: get, actionParams: { limit: 0 } },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiEquipments}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
